export default __webpack_public_path__ + "static/media/spd-hf-img.ddcd6f0a.webp";